export default __webpack_public_path__ + "static/media/VISION-QUICK.d37ae2dd.png";